import axios from 'axios';

const deleteStoreApi = async (values, token, langIsoCode) => {
  try {
    const res = await axios.post('/Store/delete', values, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default deleteStoreApi;
